// Boot-time waits used by app-main.ts before React mounts (moved out of app-main to keep it
// within its frozen size; behaviour unchanged).

// The entry stylesheet is script-inserted (vite.config.ts, door-async-main-css): render-blocking
// only where `blocking="render"` is supported, and never on #/login. Every React mount waits for
// it, so no route can paint unstyled on Safari or Firefox, which ignore that attribute.
export function mainStylesheetReady(): Promise<void> {
    const link = document.getElementById('main-css');
    // Dev serves CSS through JS (no #main-css); a loaded sheet has `.sheet`.
    if (!(link instanceof HTMLLinkElement) || link.sheet) return Promise.resolve();
    return new Promise((resolve) => {
        // An error resolves too: the door must still mount, unstyled beats blank.
        link.addEventListener('load', () => resolve(), { once: true });
        link.addEventListener('error', () => resolve(), { once: true });
    });
}

// LoginView retires the static shell on mount. If that happens before the shell's poster has
// painted, the poster first appears from React, after the whole JS chain (LCP 2.1 s -> 4 s on
// Lighthouse mobile). Capped: a slow poster never holds the form back more than 1.5 s.
export function shellPosterShown(): Promise<void> {
    const img = document.querySelector('#door-shell .ds-img');
    if (!(img instanceof HTMLImageElement) || !img.src) return Promise.resolve();
    const decoded = img.decode().catch(() => undefined);
    const cap = new Promise<void>((resolve) => { setTimeout(resolve, 1500); });
    return Promise.race([decoded, cap]).then(() => new Promise<void>((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
    }));
}
